import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-kt-scroll", "data-kt-scroll-max-height", "data-kt-scroll-height", "data-kt-scroll-offset", "data-kt-scroll-wrappers", "data-kt-scroll-dependencies"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "scroll-y",
    "data-kt-scroll": _ctx.scroll,
    "data-kt-scroll-max-height": _ctx.getMaxHeight,
    "data-kt-scroll-height": _ctx.getHeight,
    "data-kt-scroll-offset": _ctx.offset,
    "data-kt-scroll-wrappers": _ctx.bodyId,
    "data-kt-scroll-dependencies": _ctx.dependencies
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}